import ru from 'vuetify/src/locale/ru.ts'

export default {
    $vuetify: {
        ...ru,
        companyName: 'Кафе Софт',
        auth: {
            login: {
                formTitle: 'Авторизация',
                userName: 'Email пользователя',
                userPhone: 'Телефон пользователя',
                password: 'Пароль',
                loginBtn: 'Войти',
                registrationBtn: 'Регистрация',
            }
        },
        menu: {
            account: 'Учетная запись',
            logout: 'Выход'
        },
        page: {
            Home: {
              name: 'Домашняя'
            },
            Profile: {
                name: 'Профайл',
                displayName: 'Отображаемое имя',
                avatar: 'Аватар',
            },
            ChatList:{
                name: 'Список чатов'
            },
            SeriesNumberDictionary:{
                name: 'Серии номеров',
                nameTitle: 'Наименование',
                crudName: 'Серию номеров',
                prefix: 'Префикс',
                length: 'Длинна',
                sequence: 'Текущее значение',
                step: 'Шаг',
            },
            DepartmentDictionary:{
                name: 'Департаменты',
                nameTitle: 'Наименование',
                crudName: 'Департамент',
            },
            ServiceTypeDictionary:{
                name: 'Типы заявок',
                nameTitle: 'Наименование',
                crudName: 'Тип заявки',
            },
            LicenseTypeDictionary:{
                name: 'Типы лицензий',
                nameTitle: 'Наименование',
                crudName: 'Тип лицензии',
            },
            ClientServiceTypeDictionary:{
                name: 'Типы обслуживания',
                nameTitle: 'Наименование',
                crudName: 'Тип обслуживания',
            },
            SoftwareVersionTypeDictionary:{
                name: 'Версии iiko',
                nameTitle: 'Наименование',
                crudName: 'Версия iiko',
            },
            CompanyDictionary:{
                name: 'Компании',
                nameTitle: 'Наименование (ИП, ТОО)',
                crudName: 'Компании',
            },
            ServiceImportanceDictionary:{
                name: 'Важность заявок',
                nameTitle: 'Наименование',
                crudName: 'Важность заявки',
                color: 'Цвет',
                maxResolveTime: 'Время исполнения',
            },
            ServiceVisitTypeDictionary:{
                name: 'Выезд',
                nameTitle: 'Наименование',
                crudName: 'Выезд',
            },
            PositionTypeDictionary:{
                name: 'Должности',
                nameTitle: 'Наименование',
                crudName: 'Должности',
            },
            DocumentTypeDictionary:{
                name: 'Типы документов',
                nameTitle: 'Наименование',
                crudName: 'Тип документа',
            },
            Settings:{
                name: 'Настроки',
                nameTitle: 'Настроки',
                crudName: 'Настроки',
                localTimeOffset: 'Локальное время',
                delayedServiceNotificationOffset: 'Время напоминания об отложенной заявке',
                serviceNumberSeries: 'Серия номеров - внутренних заявок',
                clientTicketNumberSeries: 'Серия номеров - внешних заявок',
            },
            Users:{
                name: 'Пользователи',
                nameTitle: 'Пользователь',
                crudName: 'Пользователя',
                username: 'Пользователь',
                displayName: 'Отображаемое имя',
                email: 'Email',
                phone: 'Телефон',
                roles: 'Роли',
                isDisabled: 'Активен',
                newPassword: 'Новый пароль',
                password: 'Пароль',
                confirmPassword: 'Подтвердите пароль',
                searchByName: 'Поиск по имени'
            },
            Services:{
                name: 'Заявки',
                number: 'Номер',
                client: 'Клиент',
                serviceType: 'Тип',
                serviceImportant: 'Важность',
                createDate: 'Дата создания',
                serviceTypeLabel: 'Статус заявки',
                serviceStatus: 'Статус',
                serviceDepartment: 'Департамент',
                executors: 'Исполнители',
                search: 'Поиск',
                serviceDate: 'Дата выполнения'
            },
            ServicesCard: {
                name: 'Карточка заявки',
                number: 'Номер',
                clientName: 'Клиент',
                department: 'Департамент',
                serviceType: 'Тип',
                serviceTypeDescription: 'Доп описание по типу',
                serviceImportance: 'Важность',
                externalNumber: 'Внешний номер',
                description: 'Описание',
                status: 'Статус',
                serviceVisitType: 'Выезд',
                serviceDate: 'Дата выполнения',
                clientPhone: 'Контактный телефон',
                solution: 'Решение',
                clientContact: 'Контакты клиентов',
            },
            ExecutorServices: {
                name: 'Заявки',
            },
            ExecutorServicesCard: {
                name: 'Карточка заявки',
            },
            Clients:{
                name: 'Клиенты',
                companyName: 'Компания',
                createAt: 'Дата создания карточки',
                clientName: 'Название',
                address: 'Адрес',
                licenseType: 'Тип лицензии',
                serviceType: 'Тип обслуживания',
                parentClientName: 'Название род. клиента',
            },
            ClientsCard: {
                name: 'Карточка клиента',
                companyName: 'Название компании',
                parentClientName: 'Название род. клиента',
                clientName: 'Название',
                address: 'Адрес',
                launchDate: 'Дата запуска',
                closeDate: 'Дата закрытия',
                licenseType: 'Тип лицензии',
                softwareVersionType: 'Версия программы',
                licenseDescription: 'Описание лицензии',
                serverAddress: 'Адрес сервера',
                hostingDate: 'Дата хостинга',
                serverPassword: 'Пароль админа iiko',
                networkDescription: 'Инфо по сетевому оборудованию',
                childClients:{
                    name: 'Дочерние клиенты',
                },
                serviceHistory: {
                    name: 'История обслуживания',
                    crudName: 'Историю обслуживания',
                    clientServiceType: 'Тип обслуживания',
                    startDate: 'Дата начала',
                    endDate: 'Дата окончания'
                },
                suspendHistory: {
                    name: 'История приостановки',
                    crudName: 'Историю приостановки',
                    description: 'Описание',
                    startDate: 'Дата начала',
                    endDate: 'Дата окончания'
                },
                webCash: {
                    name: 'WEB Касса',
                    crudName: 'WEB Касса',
                    title: 'Название',
                    number: 'Номер',
                    login: 'Логин',
                    password: 'Пароль'
                },
                stations: {
                    name: 'Станции',
                    crudName: 'Станция',
                    title: 'Название',
                    TeamViewerId: 'TeamViewer Id',
                    TeamViewerPwd: 'TeamViewer пароль',
                    AnyDeskId: 'AnyDesk Id',
                    AnyDeskPwd: 'AnyDesk пароль',
                    description: 'Описание'
                },
                printers: {
                    name: 'Принтеры',
                    crudName: 'Принтер',
                    title: 'Название',
                    ipAddress: 'IP адрес',
                    printerConnectionType: 'Тип соединения',
                    clientStation: 'Станция',
                    image: 'Изображение'
                },
                contact: {
                    name: 'Контакты',
                    crudName: 'Контакт',
                    fio: 'Имя',
                    phone: 'Телефон',
                    email: 'Email',
                    position: 'Должность',
                    displayName: 'Оторажаемое имя',
                    password: 'Пароль',
                },
                document: {
                    name: 'Документы',
                    crudName: 'Документ',
                    documentType: 'Тип документа',
                    description: 'Описание',
                    file: 'Файл',
                },
                remote:{
                    name: 'Доступы',
                    crudName: 'Доступы',
                    login: 'Логин',
                    password: 'Пароль',
                    url: 'URL',
                    key: 'Ключ',
                    value: 'Значение'
                },
                services:{
                    name: 'Заявки',
                }
            },
            ClientTicketList: {
                name: 'Обращения',
                ticketTypeLabel: 'Статус',
                fields: {
                    number: 'Номер',
                    clientName: 'Имя клиента',
                    name: 'Заголовок',
                    status: 'Статус',
                    manager: 'Менеджер',
                }
            },
            ClientTicketCard:{
                name: 'Обращение',
                fields: {
                    name: 'Заголовок',
                    status: 'Статус',
                    description: 'Описание',
                }
            },
            KnowledgeBase: {
                name: 'База знаний',
                search: 'Поиск',
                articleNo: 'Номер',
                title: 'Название',
                issue: 'Проблема',
                solution: 'Решение',
                attachedFiles: 'Прикрепленные файлы',
            },
            KnowledgeBaseCard: {
                name: 'База знаний',
            },
            all: {
                details: 'Детали',
                history: "История",
                createdBy: 'Создал',
                createAt: 'Дата создания',
                updateBy: 'Изменил',
                updateAt: 'Дата изменения',
                state: 'Статус',
                settings: 'Настройки',
                activate: 'Активность',
                options: 'Настройки',
                quickAccess: 'Быстрый доступ',
                deleteMsg: 'Вы уверенны что хотите удалить эту запись?',
                txtNeedCreateClient: 'Сначала необходимо создать карточку клиента'
            },
            action: {
                btnCustom: 'Индивидуальный',
                btnSave: 'Сохранить',
                btnClose: 'Закрыть',
                btnCancel: 'Отмена',
                btnAdd: 'Добавить',
                btnEdit: 'Редактировать',
                btnDelete: 'Удалить',
                btnFilter: 'Фильтр',
                btnClear: 'Очистить',
                btnNext: 'Дальше',
                btnBack: 'Назад',
                btnYes: 'Да',
                btnSend: 'Отправить',
                formAddTitle: 'Добавить \'{0}\'',
                formEditTitle: 'Редактировать \'{0}\'',
                requiredField: '* указывает на обязательное поле',
                confirmDelete: 'Вы уверены, что хотите удалить \'{0}\'?',
                titleAction: 'Действия',
                titleDataNotFound: 'Данные не найдены',
                search: 'Поиск',
                copyLinkSuccess: 'Ссылка скопированна'
            }
        },
        validation:{
            required: 'Обязательное поле',
            onlyString: 'Только буквы',
            onlyNumber: 'Только цифры',
            onlyStringAndNumber: 'Цифры и буквы',
            email: 'Не валидный Email',
            newPassword: 'Пароль должен содержать как минимум 1 заглавную, 1 строчную, 1 цифру и 1 специальный символ. Минимальная длина 8 символов',
            confirmPassword: 'Пароль должен совпадать',
            phone: 'Неверный формат телефона',
            minLength: 'Длина должна быть больше {0}',
            maxLength: 'Длина должна быть меньше {0}',
            minVal: 'Значение должно быть больше {0}',
            maxVal: 'Значение должно быть меньше {0}',
        }
    }
}